module.exports = __webpack_public_path__ + "img/carousel-clientes-12.6661bd74.png";